import { render, staticRenderFns } from "./CambiarPlaza.vue?vue&type=template&id=3e82191d"
import script from "./CambiarPlaza.vue?vue&type=script&lang=js"
export * from "./CambiarPlaza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports